var _rect, _rect2, _rect3, _rect4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoDoktor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.4102,
    y: 0.5,
    width: 18.1819,
    height: 10.9091,
    fill: "#B3E0DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.4102,
    y: 29.5908,
    width: 18.1819,
    height: 10.9091,
    fill: "#83D6FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5898,
    y: 29.5908,
    width: 18.1819,
    height: 10.9091,
    transform: "rotate(-90 29.5898 29.5908)",
    fill: "#7ECCC4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 29.5908,
    width: 18.1819,
    height: 10.9091,
    transform: "rotate(-90 0.5 29.5908)",
    fill: "#03A8F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.592 11.4092H11.4102V29.591H29.592V20.5004L15.2742 29.1604V11.8399L29.592 20.4999V11.4092Z",
    fill: "#0279BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDoktor);
export default __webpack_public_path__ + "static/media/videoDoktor.f63fb0ec221e63288d24148316e0635c.svg";
export { ForwardRef as ReactComponent };